import React, { useContext } from 'react'
import "./foodItem.css"
import { assets } from '../../assets/assets';
import { StoreContext } from '../../context/StoreContext';
function FoodItem(props) {
  const { id, name, price, description, image } = props;
  const { cartItem, addToCart, removeFromCart } = useContext(StoreContext)
  return (
    <div className='food-item'>
      <div className="food-item-image-container">
        <img src={image} className='food-item-image' alt="" />
        {
          !cartItem[id]
            ? <img className='add' onClick={() => addToCart(id)} src={assets.add_icon_white} alt='' />
            : <div className="food-item-conter">
              <img src={assets.remove_icon_red} onClick={() => removeFromCart(id)} alt="" />
              <p>{cartItem[id]}</p>
              <img src={assets.add_icon_green} onClick={() => addToCart(id)} alt="" />
            </div>
        }
      </div>
      <div className="food-item-info">
        <div className="food-item-name-rating">
          <p>{name}</p>
          <img src={assets.rating_starts} alt="" loading='lazy' />
        </div>
        <div className="food-item-desc">
          {description}
        </div>
        <p className='food-item-price'>$ {price}</p>
      </div>
    </div>
  )
}

export default FoodItem